import classNames from "classnames";
import React from "react";

export type CaTableProps = React.DetailedHTMLProps<
  React.TableHTMLAttributes<HTMLTableElement>,
  HTMLTableElement
> & {
  align?: "left" | "center" | "right";
  withoutShadow?: boolean;
};

function CaTable({ className, align = "left", withoutShadow, ...props }: CaTableProps) {
  return (
    <div
      className={classNames(
        `w-full overflow-auto rounded-sm bg-white`,
        !withoutShadow && "shadow-sm",
      )}
    >
      <table
        className={classNames("w-full caption-bottom text-sm", className)}
        align={align}
        {...props}
      />
    </div>
  );
}

export default CaTable;
